import { AxiosResponse } from "axios";
import { SubmissionResponse, Submission,
    Voivodeship, PageVoivodeship,
    District, PageDistrict,
    Commune, PageCommune,
    City, PageCity,
    Street, PageStreet,
    Category, PageCategory } from "../dto/dto";
import AxiosInstance from "../utils/axiosConfig";

const ROOT = window.location.origin === "http://localhost:3000"
        ? "http://localhost:8080"
        : window.location.origin;

export const getVoivodeships = async (): Promise<Voivodeship[]> => {
    const response: AxiosResponse<PageVoivodeship> = await AxiosInstance.get(
        `${ROOT}/o/location/v1.0/voivodeships?page=${1}&pageSize=${100}`
    );
    const items = response.data.items ?? []
    return items.map(item => ({
        ...item,
    }));
};

export const getDistricts = async (
    voivodeshipId: string | undefined
): Promise<District[]> => {
    const response: AxiosResponse<PageDistrict> = await AxiosInstance.get(
        `${ROOT}/o/location/v1.0/districts/${voivodeshipId ?? ''}?page=${1}&pageSize=${100}`
    );
    const items = response.data.items ?? []
    return items.map(item => ({
        ...item,
    }));
};

export const getCommunes = async (
    districtId: string | undefined
): Promise<Commune[]> => {
    const response: AxiosResponse<PageCommune> = await AxiosInstance.get(
        `${ROOT}/o/location/v1.0/communes/${districtId ?? ''}?page=${1}&pageSize=${100}`
    );
    const items = response.data.items ?? []
    return items.map(item => ({
        ...item,
    }));
};

export const getCities = async (
    communeId: string | undefined
): Promise<City[]> => {
    const response: AxiosResponse<PageCity> = await AxiosInstance.get(
        `${ROOT}/o/location/v1.0/cities/${communeId ?? ''}?page=${1}&pageSize=${100}`
    );
    const items = response.data.items ?? []
    return items.map(item => ({
        ...item,
    }));
};

export const getStreets = async (
    cityId: string | undefined
): Promise<Street[]> => {
    const response: AxiosResponse<PageStreet> = await AxiosInstance.get(
        `${ROOT}/o/location/v1.0/streets/${cityId ?? ''}`
    );
    const items = response.data.items ?? []
    return items.map(item => ({
        ...item,
    }));
};

export async function autocompleteStreets(cityId: string | undefined, query: string): Promise<Street[]> {
    const response: AxiosResponse<PageStreet> = await AxiosInstance.post(`${ROOT}/o/location/v1.0/streets/autocomplete/${cityId ?? ''}?maxResults=20&page=1&pageSize=20`, {
        keyword: query
    });
    return response.data.items || [];
}

export const getCategories = async (): Promise<Category[]> => {
    const response: AxiosResponse<PageCategory> = await AxiosInstance.get(
        `${ROOT}/o/location/v1.0/categories?page=${1}&pageSize=${100}`
    );
    const items = response.data.items ?? []
    return items.map(item => ({
        ...item,
    }));
};

export const submitForm = async (
    submitValues: Submission
): Promise<SubmissionResponse> => {
    const response: AxiosResponse<SubmissionResponse> = await AxiosInstance.post(
        `${ROOT}/o/location/v1.0/submit`,
        submitValues
    );
    return response.data;
};

